import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-4015" />, document.getElementById("root"));